import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaMinus, FaSave, FaTimes, FaChevronRight } from 'react-icons/fa';
import FileUpload from 'ui-component/FileUpload';
import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import Select from 'react-select';
import { toast } from 'react-hot-toast';
import InputGroup from 'react-bootstrap/InputGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ReactSelect from 'react-select';
import { useForm } from 'react-hook-form';

function PaymentFormModalMobile({ showPaymentModal, editPayment, handleClose, onFormSubmit, estimate, defaultPaymentType, selectedPaymentDetails, source }) {
    const [disableStatus, setDisablestatus] = useState(false);
    const [imageId, setImageId] = useState(null);
    const [selectedPaymentType, setSelectedPaymentType] = useState('Bank Transfer');
    const [creditNoteLists, setCreditNoteLists] = useState([]);
    const [amountToPay, setAmountToPay] = useState(0);
    const [totalOpen, setTotalOpen] = useState(0);
    const [convertedTotalOpen, setConvertedTotalOpen] = useState(0);
    const [defaultCurrency, setDefaultCurrency] = useState('USD($)');
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [selectedCreditNote, setSelectedCreditNote] = useState(null);

    const bankPaymentTypes = [
        { label: 'Bank Transfer', value: 'Bank Transfer' },
        { label: 'Bank Charges', value: 'Bank Charges' },
        { label: 'Credit Card', value: 'Credit Card' },
        { label: 'Bank Cheque', value: 'Bank Cheque' },
        { label: 'Cash', value: 'Cash' },
        { label: 'USDT', value: 'USDT' },
        { label: 'Credit Note', value: 'Credit Note' },
    ];

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch
    } = useForm();


    const currencies = [
        { label: 'USD($)', value: 'usd' },
        { label: 'EUR(€)', value: 'eur' },
        { label: 'AED(AED)', value: 'aed' }
    ];     

    useEffect(() => {
        
        const id = estimate?.transit_company_id || estimate?.customer_id;
		api.getSelectOptionsListWithId('get_available_credit_notes_by_invoice', id).then((res) => {
            if (res?.status) {
                const tempList = res.data.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setCreditNoteLists(tempList);
            }
		});
    }, [])
    
    useEffect(() => {
		
        reset({
            paymentAmount: editPayment?.amount_paid || 0,
            paymentDate: editPayment?.payment_date ? moment(editPayment?.payment_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        });
        setImageId(editPayment?.payment_attachment?.id || null);
        setConvertedTotalOpen(estimate?.converted_currency_open_balance[estimate?.currency])

        if (estimate?.currency === 'eur') {
            setDefaultCurrency('EUR(€)');
        } else if (estimate?.currency === 'usd') {
            setDefaultCurrency('USD($)');
        } else if (estimate?.currency === 'aed') {
            setDefaultCurrency('AED(AED)');
        } else {
            setDefaultCurrency('USD($)');
        }
        setSelectedCurrency(estimate?.currency);
        

    }, [showPaymentModal, editPayment]);

    useEffect(() => {
        
        const subscription = watch((value, { name, type, currency }) => {
            
            if (name == 'paymentAmount' && type == 'change') {
                calculateNewOpen(value?.paymentAmount, selectedCurrency);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, selectedCurrency]);

    useEffect(() => {
        if (defaultPaymentType != null) {
            setSelectedPaymentType(defaultPaymentType)
        } else {
            setSelectedPaymentType('')
        }
        if (selectedPaymentDetails != null) {
            setAmountToPay(selectedPaymentDetails?.amount_paid);
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[selectedCurrency]) + Number(selectedPaymentDetails?.amount_paid));
        } else {
            setSelectedPaymentType('')
        }
    }, [defaultPaymentType, selectedPaymentDetails])

    const calculateNewOpen = (paid, currency) => {
        setAmountToPay(paid)
        if (editPayment) {
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[currency]) + Number(editPayment?.amount_paid) - Number(paid));
        } else {
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[currency]) - Number(paid));
        }
    };

    const handleOnSubmit = (data) => {
        if (!selectedPaymentType) {
            toast.error('Payment Type is required');
            return false;
        }
        if (amountToPay === '0.00' || amountToPay === 0 || amountToPay === '') {
            toast.error('Amount is required');
            return false
        }
        onFormSubmit &&
            onFormSubmit({
                payment_type: selectedPaymentType,
                credit_note_id: selectedCreditNote?.id,
                payment_date: data?.paymentDate,
                // amount_paid: data?.paymentAmount,
                amount_paid: amountToPay,
                currency: selectedCurrency,
                estimation_attachment_id: imageId,
                payment_id: editPayment?.id || undefined
            });
    };

    const handleFileUpload = (e) => {
        const files = e.target.files;
        setDisablestatus(true);
        if (files && files.length > 0) {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('payment_file', files[i]);
            }
            if (source === 'invoice') {
                formData.append('estimation_id', estimate?.id);
                api.addInvoicePaymentFile(formData).then((res) => {
                    setDisablestatus(false);
                    setImageId(res.data);
                });
            } else {
                formData.append('sales_order_id', estimate?.id);
                api.addSalesOrderPaymentFile(formData).then((res) => {
                    setDisablestatus(false);
                    setImageId(res.data);
                });
            }

        }
    };

    const handleChangeCurrency = (currency) => {
        setConvertedTotalOpen(estimate?.converted_currency_open_balance[currency?.value])
        setDefaultCurrency(currency.label);
        setSelectedCurrency(currency?.value);
    }

    const handleCreditChange = (e) => {
        setSelectedCreditNote(e);
        setAmountToPay(e?.amount);
        setSelectedCurrency(e?.currency);
        
    }

    useEffect(() => { 
        const computeOpenBalance = estimate?.converted_currency_open_balance[selectedCurrency] - amountToPay;
        setConvertedTotalOpen(computeOpenBalance)
    }, [selectedCurrency, amountToPay])
    
    if (!showPaymentModal) return null;

    return (
			<div
				className="d-flex"
				style={{
					width: '100vw',
					height: '100dvh',
					position: 'fixed',
					left: 0,
					top: 0,
					zIndex: 20,
					background: 'rgba(0,0,0,0.07)',
					justifyContent: 'center',
					alignItems: 'end',
					paddingBottom: '90px',
					backdropFilter: 'blur(8px)',
					WebkitBackdropFilter: 'blur(8px)'
				}}
			>
				<div
					className="popup product-popup-mobile d-md-none"
					style={{
						position: 'relative',
						transform: 'none',
						top: 0,
						left: 0,
						maxHeight: 'calc(100dvh - 110px)',
						maxWidth: '90%',
						background: '#fff',
						borderRadius: 12,
						boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
						width: '100%',
						minHeight: '70dvh',
						padding: '24px 16px 0 16px',
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					{/* Header */}
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
						<h2 className="h4 mb-0 font-weight-bold">Register payment</h2>
					</div>
					<form onSubmit={handleSubmit(handleOnSubmit)}>
						<div style={{ marginBottom: '20px' }}>
							<div className="row" style={{ marginTop: '15px' }}>
								<div className="col-12 text-center">
									You are going to settle an amount for <br /> {source === 'invoice' ? 'Invoice ' : 'Sales Order '}
									<span className="text-primary font500">{estimate?.invoice_number ?? estimate?.estimation_number}</span>.
								</div>
							</div>
						</div>
						<div className="row m-0">
							{/* Payment Type */}
							<div className="form-group col-md-6">
								<label htmlFor="paymentType">Payment Type</label>
								<Select
									menuPosition={'fixed'}
									options={bankPaymentTypes}
									value={bankPaymentTypes?.find((y) => y?.value == selectedPaymentType)}
									className="rs-container"
									classNamePrefix="rs"
									placeholder="Select or type..."
									onChange={(e) => {
										setSelectedPaymentType(e?.value);
									}}
								/>
								{errors.paymentType && <p className="mt-1 text-danger">Payment Type is required</p>}
							</div>
							{/* Date */}
							<div className="form-group col-md-6">
								<label htmlFor="paymentAmount">Date</label>
								<input type="date" className="form-control" id="paymentDate" {...register('paymentDate', { required: true })} />
								{errors.paymentDate && <p className="mt-1 text-danger">Invalid Date</p>}
							</div>
							{/* Credit Note */}
							{selectedPaymentType === 'Credit Note' && (
								<div className="form-group col-md-12">
									<label htmlFor="paymentType">Available Credit Note</label>
									<ReactSelect
										className="rs-container"
										classNamePrefix="rs"
										options={[...creditNoteLists]?.map((m) => ({
											...m,
											optionAttribute: m.attribute
										}))}
										menuPlacement="auto"
										menuPosition="fixed"
										placeholder="Select or type..."
										formatOptionLabel={({ label, optionAttribute }) => <div dangerouslySetInnerHTML={{ __html: label }}></div>}
										onChange={(e) => {
											handleCreditChange(e);
										}}
										styles={{
											menu: (provided) => ({
												...provided,
												overflowY: 'auto'
											}),
											option: (provided, { selectProps, data }) => {
												const index = selectProps.options.findIndex((option) => option.value === data.value);
												return {
													...provided,
													marginBottom: '5px',
													marginTop: index === 0 ? '10px' : 0
												};
											}
										}}
									/>
									{errors.invoice && <p className="mt-1 text-danger">Invoice is required</p>}
								</div>
							)}
							{/* Amount */}
							<div className="form-group col-md-6">
								<label htmlFor="paymentAmount">Amount </label>
								<div className="custom-input-group payment-input-group">
									{selectedPaymentType === 'Credit Note' ? (
										<div className=" d-flex input-group-2-form input-group-2-form-currency">
											<input
												type="text"
												className="form-control left-input"
												id="inputName"
												value={selectedCreditNote?.currency_label}
												disabled={true}
												style={{ width: '75px' }}
											/>
											<input
												type="number"
												className="form-control right-input"
												value={amountToPay}
												onFocus={(event) => {
													if (event.target.value == '0.00' || event.target.value == '0') {
														setAmountToPay('');
													}
													event.target.select();
												}}
												autoComplete={'off'}
												onClick={(e) => {
													if (e.target.value === '0' || e.target.value === '0.00') {
														setAmountToPay('');
													}
												}}
												onBlur={(e) => {
													if (e.target.value === '' || e.target.value === '0' || e.target.value === '0.00') {
														setAmountToPay('0.00');
													}
												}}
												onChange={(e) => {
													setAmountToPay(e.target.value);
												}}
											/>
										</div>
									) : (
										<>
											<InputGroup className="mb-3 d-flex">
												<DropdownButton variant="outline-secondary" title={defaultCurrency} id="input-group-dropdown-1">
													{currencies.map((currency) => (
														<Dropdown.Item
															href="#"
															key={currency.value}
															onClick={() => {
																handleChangeCurrency(currency);
															}}
														>
															{currency.label}
														</Dropdown.Item>
													))}
												</DropdownButton>
												<input
													type="text"
													className="form-control"
													// id="paymentAmount" {...register('paymentAmount', { required: true, min: 1 })}
													value={amountToPay}
													onFocus={(event) => {
														if (event.target.value == '0.00' || event.target.value == '0') {
															setAmountToPay('');
														}
														event.target.select();
													}}
													onChange={(e) => {
														setAmountToPay(e.target.value);
													}}
													autoComplete={'off'}
													autoFocus
												/>
											</InputGroup>
											<div
												style={{
													position: 'absolute',
													top: '40%',
													right: '13px',
													zIndex: 3,
												}}
											>
												<button
													className="btn btn-primary-small-fit" 
													onClick={() => {
														setAmountToPay(convertedTotalOpen)
													}}
													style={{ 
														padding: '5px 8px'
													}}
													type="button"
												>
													Full
												</button>
											</div>
										</>
									)}
								</div>
								{errors.paymentAmount && <p className="mt-1 text-danger">Invalid Amount</p>}
							</div>
							{/* Open */}
							<div className="form-group col-md-6">
								<label htmlFor="paymentAmount">Open ({getCurrencySymbol(selectedCurrency)})</label>
								<input type="text" className="form-control" value={numberFormatter.format(convertedTotalOpen || 0)} readOnly />
							</div>
							{/* Attachment */}
							<div className="form-group col-md-12">
								<label htmlFor="shipmentTracking">Attachment</label>
								<FileUpload
									accept=".png,.jpg,.jpeg,.pdf"
									loading={disableStatus}
									onChange={(e) => {
										handleFileUpload(e);
									}}
									selectedValue={editPayment?.payment_attachment}
								/>
							</div>
						</div>
						{/* Sticky bottom buttons */}
						<div
							className="btnarea"
							style={{
								position: 'sticky',
								bottom: 0,
								left: 0,
								width: '100%',
								background: '#fff',
								padding: '16px 0 12px 0',
								zIndex: 30,
								display: 'flex',
								gap: 10,
								justifyContent: 'center',
								marginTop: 'auto'
							}}
						>
							<button className="btn btn-primary btn-outlined-main" type="submit" disabled={disableStatus} style={{ marginRight: '10px' }}>
								<FaSave /> {editPayment ? 'Update' : 'Save'}
							</button>
							<button className="btn btn-primary btn-outlined-main" onClick={handleClose}>
								Cancel
							</button>
						</div>
					</form>
				</div>
			</div>
		);
}

export default PaymentFormModalMobile;










